import React from 'react';
import { motion } from 'framer-motion';
export function WhyThisMattersSection() {
  return <section className="py-24 px-6 md:px-8 bg-charcoal-950 relative overflow-hidden" data-id="element-66">
      {/* Decorative large quote mark */}
      <div className="absolute top-10 left-4 md:left-10 text-[15rem] md:text-[25rem] font-serif text-charcoal-800 leading-none select-none pointer-events-none" aria-hidden="true" data-id="element-67">
        &ldquo;
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center md:text-left" data-id="element-69">
          <p className="text-patriotRed uppercase tracking-[0.2em] text-sm font-semibold mb-4" data-id="element-70">
            THE MANIFESTO
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-offwhite mb-10 leading-tight" data-id="element-71">
            A Perspective on Freedom.
          </h2>

          <div className="space-y-8 text-lg md:text-xl font-light text-offwhite-secondary leading-relaxed" data-id="element-72">
            <p data-id="element-73">
              In an era where the First Amendment is tested daily, where voices
              are silenced both by algorithms and bullets, this book stands as a
              testament to the enduring power of the word. It is a chronicle of
              what happens when a society forgets that the right to speak freely
              is the foundation upon which all other rights are built.
            </p>
          </div>

          <div className="my-16 w-16 h-[1px] bg-patriotRed mx-auto md:mx-0" aria-hidden="true" data-id="element-74" />

          <div className="text-center max-w-3xl mx-auto" data-id="element-75">
            <h3 className="text-2xl font-bold text-offwhite mb-6 font-serif" data-id="element-76">
              The Final Word
            </h3>
            <p className="text-xl md:text-2xl font-medium text-offwhite italic leading-relaxed" data-id="element-77">
              Charlie Kirk didn't just talk about freedom: he lived it, breathed
              it, and ultimately gave everything for it. This is his story. This
              is our vision.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}